
// You can write more code here

/* START OF COMPILED CODE */

import { LevelManager } from "~/js/game/LevelManager";

import Powerup from "../../game/powerups/Powerup";
/* START-USER-IMPORTS */
import { Sounds } from "../../sounds";
/* END-USER-IMPORTS */

export default class TweetyBirdPowerup extends Powerup {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // TweetyBird
    const tweetyBird = scene.add.container(0, 0);
    this.add(tweetyBird);

    // tweetyBird_png
    const tweetyBird_png = scene.add.image(0, -100, "game-tiles", "tweety-tweety.png");
    tweetyBird_png.scaleX = 0.4;
    tweetyBird_png.scaleY = 0.4;
    tweetyBird.add(tweetyBird_png);

    this.tweetyBird = tweetyBird;
    this.tweetyBird_png = tweetyBird_png;

    /* START-USER-CTR-CODE */

    /* END-USER-CTR-CODE */
  }

  public birdDistanceFromCenter:number = 100;
  public birdSpeed = 0.4;
  private tweetyBird: Phaser.GameObjects.Container;
  private tweetyBird_png: Phaser.GameObjects.Image;
  private birdAngle:number = 0;
  /* START-USER-CODE */
  public duration:number = 1500;

  public override ApplyPowerup(levelManager: LevelManager): void {
    super.ApplyPowerup(levelManager);
    this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.Canary, Sounds.Channel.SFX, {
      volume: 0.8
    });
  }

  update(playerX: number, playerY: number, time: number, deltaTime: number) {
    super.update(playerX, playerY, time, deltaTime);

    this.birdAngle -= this.birdSpeed*deltaTime;

    let radians = this.birdAngle * (Math.PI/180);
    let x = Math.sin(radians) * this.birdDistanceFromCenter + playerX;
    let y = Math.cos(radians) * this.birdDistanceFromCenter + playerY;

    this.tweetyBird_png.x = x;
    this.tweetyBird_png.y = y;

    let size = this.tweetyBird_png.width;
    if(this.levelManager.hitObject(x,y,size,x,y)) {
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
